<template>
  <base-filter-expander :title="$t('search.transmission')" :is-valid="isValid">
    <base-tiles-grid icon-grid>
      <base-tile
        v-for="option in options"
        :id="option.id"
        :key="option.id"
        :image="option.image"
        :text="option.text"
        :is-active="transmissionIsActive(option.id)"
        type="icon"
        text-align="center"
        @store-update="updateTransmissionsInStore($event)"
      />
    </base-tiles-grid>
  </base-filter-expander>
</template>

<script>
import BaseFilterExpander from "@/components/ui/BaseFilterExpander/BaseFilterExpander.vue";
import BaseTilesGrid from "@/components/ui/BaseTilesGrid/BaseTilesGrid.vue";
import BaseTile from "@/components/ui/BaseTile/BaseTile.vue";
import transmissionTypes from "@/constants/transmissionTypes";
import { ADD_TRANSMISSION, REMOVE_TRANSMISSION } from "@/store/mutationTypes";
import { GET_DATA_FROM_API } from "@/store/actionTypes";

export default {
  name: "TransmissionSelect",
  components: {
    BaseFilterExpander,
    BaseTilesGrid,
    BaseTile
  },
  computed: {
    options() {
      return transmissionTypes;
    },
    isValid() {
      return this.$store.state.search.transmission.length > 0;
    }
  },
  methods: {
    updateTransmissionsInStore(option) {
      const action =
        option.action == "add" ? ADD_TRANSMISSION : REMOVE_TRANSMISSION;
      this.$store.commit(action, option.id);
      this.$store.dispatch(GET_DATA_FROM_API);
    },
    transmissionIsActive(transmission) {
      return this.$store.state.search.transmission.includes(transmission);
    }
  }
};
</script>
